import { V2File } from 'clients/api/fileUploads';

declare var __webpack_public_path__: string;

export type UploadRequestHandler = (
  fileContextKey: string,
  filename: string,
  blob: File,
  onSuccess?: (file: V2File) => void,
  onFailure?: (err: Error) => void,
  privateUpload?: boolean
) => void;

export type ThumbnailHandler = (fileContextKey: string, filename: string, thumbnail: string) => void;

export function uploadFile(
  fileContextKey: string,
  file: File,
  uploadRequest: UploadRequestHandler,
  loadThumbnail?: ThumbnailHandler,
  privateUpload: boolean = false
) {
  if (loadThumbnail && file.type.startsWith('image')) {
    const fileReader = new FileReader();
    fileReader.onload = onLoadEvent => {
      loadThumbnail(fileContextKey, file.name, (onLoadEvent.target as FileReader).result as string);
    };
    fileReader.readAsDataURL(file);
  }
  uploadRequest(fileContextKey, file.name, file, undefined, undefined, privateUpload);
}
